import React from 'react'
import { useSelector, useDispatch } from "react-redux"
import { delSingleItem } from '../features/productsSlice'


export default function ProductsList() {
    const dispatch = useDispatch()
    const products_ar = useSelector(state =>
        state.productsSlice.products_ar
    )


    return (
        <div className='col-md-7 text-center mx-auto'>
            {
                products_ar.map(item => {
                    return (
                        <div style={{ borderRadius: "15px", background: "rgba(255, 255, 255, 0.799)" }} key={item.id} className='shadow my-2 p-2'>
                            <button onClick={() => {
                                dispatch(delSingleItem({ delId: item.id }))
                            }} className='btn btn-danger float-end'>x</button>
                            <h4>{item.name}-{item.amount}</h4>
                        </div>
                    )
                })
            }

        </div>
    )
}
